import api from './api';
import type { DashboardStats, RecentOrder, ConversionTrendData, TransactionTrendData } from '../types';

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get<DashboardStats>('/company/dashboard/stats');
    return response.data;
  },

  async getRecentOrders(limit: number = 5): Promise<RecentOrder[]> {
    const response = await api.get<RecentOrder[]>(`/company/dashboard/recent-orders?limit=${limit}`);
    return response.data;
  },

  async getConversionTrend(days: number = 15): Promise<ConversionTrendData> {
    const response = await api.get<ConversionTrendData>(`/company/dashboard/conversion-trend?days=${days}`);
    return response.data;
  },

  async getTransactionTrend(days: number = 15): Promise<TransactionTrendData> {
    const response = await api.get<TransactionTrendData>(`/company/dashboard/transaction-trend?days=${days}`);
    return response.data;
  },
};
